import {call, fork, put, select, take} from "redux-saga/effects";
import {getUserInfo} from "../../reducers/app";
import {CODES} from "../../constants";
import API from "../../api/api";
import {merchantInfo} from "../../reducers/merchant";

function *changeFeeType(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let merchant = yield select(merchantInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        feeType: merchant.feeType ? 0 : 1
    }
    let resp = yield call(API.modifyFeeType, params)
    if (resp.code === CODES.SUCCESS) {
        yield put({type: 'SET_FEE_TYPE', payload: {feeType: merchant.feeType ? 0 : 1}})
    }
}

function *setMarkupRate(rate: number): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)

    let params = {
        email: userInfo.email,
        clientId: 'h5',
        markupRate: rate
    }
    let resp = yield call(API.modifyMarkupRate, params)
    if (resp.code === CODES.SUCCESS) {
        yield put({type: 'SET_MARK_UP_RATE', payload: {markupRate: rate}})
    }
}

export function * watchSettingsChange(): Generator<any, void, any> {
    while (true){
        let {payload} = yield take('PAY_SETTINGS_CHANGE')
        if(payload.key === 'feeType'){
            yield fork(changeFeeType)
        }else if(payload.key === 'markupRate'){
            yield fork(setMarkupRate, payload.value)
        }
    }
}
